<template>
  <div v-if="minutes || seconds !== '00'" class="flex flex-row align-center">
    <slot name="before-time"></slot>
    <p :class="`text-${color}-${intensity}`">{{ minutes }}:{{ seconds }}</p>
    <slot name="after-time"></slot>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";

const props = defineProps({
  duration: {
    type: Number,
    default: 0,
  },
  color: {
    type: String,
    default: "blue",
  },
  intensity: {
    type: Number,
    default: 500,
  },
});

const minutes = ref(0);
const seconds = ref("00");

const addZeros = (value) => {
  if (value < 10) {
    return "0" + value;
  }
  return value;
};

const initTimer = () => {
  minutes.value = props.duration - 1;
  seconds.value = 59;
};

watch(
  seconds,
  (value) => {
    if (value > 0) {
      setTimeout(() => {
        seconds.value = addZeros(seconds.value - 1);
      }, 1000);
    } else if (value === 0 && minutes.value > 0) {
      setTimeout(() => {
        minutes.value--;
        seconds.value = 59;
      }, 1000);
    }
  },
  { immediate: true }
);

onMounted(() => {
  initTimer();
});
</script>
